import React from 'react';

/**
 * Brick bond illustrations for the wall calculators
 */

export const StretcherBondSVG = () => (
  <svg viewBox="0 0 200 100" style={{ width: '100%', maxWidth: 200, height: 'auto' }}>
    {/* Row 1 */}
    <rect x="5" y="5" width="60" height="20" fill="#D2691E" stroke="#8B4513" strokeWidth="1" rx="1"/>
    <rect x="68" y="5" width="60" height="20" fill="#CD853F" stroke="#8B4513" strokeWidth="1" rx="1"/>
    <rect x="131" y="5" width="60" height="20" fill="#D2691E" stroke="#8B4513" strokeWidth="1" rx="1"/>
    {/* Row 2 - offset */}
    <rect x="35" y="28" width="60" height="20" fill="#CD853F" stroke="#8B4513" strokeWidth="1" rx="1"/>
    <rect x="98" y="28" width="60" height="20" fill="#D2691E" stroke="#8B4513" strokeWidth="1" rx="1"/>
    <rect x="161" y="28" width="30" height="20" fill="#CD853F" stroke="#8B4513" strokeWidth="1" rx="1"/>
    {/* Row 3 */}
    <rect x="5" y="51" width="60" height="20" fill="#D2691E" stroke="#8B4513" strokeWidth="1" rx="1"/>
    <rect x="68" y="51" width="60" height="20" fill="#CD853F" stroke="#8B4513" strokeWidth="1" rx="1"/>
    <rect x="131" y="51" width="60" height="20" fill="#D2691E" stroke="#8B4513" strokeWidth="1" rx="1"/>
    {/* Row 4 - offset */}
    <rect x="35" y="74" width="60" height="20" fill="#CD853F" stroke="#8B4513" strokeWidth="1" rx="1"/>
    <rect x="98" y="74" width="60" height="20" fill="#D2691E" stroke="#8B4513" strokeWidth="1" rx="1"/>
    <rect x="161" y="74" width="30" height="20" fill="#CD853F" stroke="#8B4513" strokeWidth="1" rx="1"/>
    {/* Mortar lines */}
    <line x1="0" y1="27" x2="200" y2="27" stroke="#A0A0A0" strokeWidth="2" strokeDasharray="2,2"/>
    <line x1="0" y1="50" x2="200" y2="50" stroke="#A0A0A0" strokeWidth="2" strokeDasharray="2,2"/>
    <line x1="0" y1="73" x2="200" y2="73" stroke="#A0A0A0" strokeWidth="2" strokeDasharray="2,2"/>
  </svg>
);

export const EnglishBondSVG = () => (
  <svg viewBox="0 0 200 100" style={{ width: '100%', maxWidth: 200, height: 'auto' }}>
    {/* Row 1 - Stretcher course */}
    <rect x="5" y="5" width="60" height="20" fill="#D2691E" stroke="#8B4513" strokeWidth="1" rx="1"/>
    <rect x="68" y="5" width="60" height="20" fill="#CD853F" stroke="#8B4513" strokeWidth="1" rx="1"/>
    <rect x="131" y="5" width="60" height="20" fill="#D2691E" stroke="#8B4513" strokeWidth="1" rx="1"/>
    {/* Row 2 - Header course (bricks showing end face) */}
    <rect x="5" y="28" width="28" height="20" fill="#B8860B" stroke="#8B4513" strokeWidth="1" rx="1"/>
    <rect x="36" y="28" width="28" height="20" fill="#DAA520" stroke="#8B4513" strokeWidth="1" rx="1"/>
    <rect x="67" y="28" width="28" height="20" fill="#B8860B" stroke="#8B4513" strokeWidth="1" rx="1"/>
    <rect x="98" y="28" width="28" height="20" fill="#DAA520" stroke="#8B4513" strokeWidth="1" rx="1"/>
    <rect x="129" y="28" width="28" height="20" fill="#B8860B" stroke="#8B4513" strokeWidth="1" rx="1"/>
    <rect x="160" y="28" width="28" height="20" fill="#DAA520" stroke="#8B4513" strokeWidth="1" rx="1"/>
    {/* Row 3 - Stretcher course */}
    <rect x="35" y="51" width="60" height="20" fill="#CD853F" stroke="#8B4513" strokeWidth="1" rx="1"/>
    <rect x="98" y="51" width="60" height="20" fill="#D2691E" stroke="#8B4513" strokeWidth="1" rx="1"/>
    <rect x="161" y="51" width="30" height="20" fill="#CD853F" stroke="#8B4513" strokeWidth="1" rx="1"/>
    {/* Row 4 - Header course */}
    <rect x="20" y="74" width="28" height="20" fill="#DAA520" stroke="#8B4513" strokeWidth="1" rx="1"/>
    <rect x="51" y="74" width="28" height="20" fill="#B8860B" stroke="#8B4513" strokeWidth="1" rx="1"/>
    <rect x="82" y="74" width="28" height="20" fill="#DAA520" stroke="#8B4513" strokeWidth="1" rx="1"/>
    <rect x="113" y="74" width="28" height="20" fill="#B8860B" stroke="#8B4513" strokeWidth="1" rx="1"/>
    <rect x="144" y="74" width="28" height="20" fill="#DAA520" stroke="#8B4513" strokeWidth="1" rx="1"/>
    <rect x="175" y="74" width="20" height="20" fill="#B8860B" stroke="#8B4513" strokeWidth="1" rx="1"/>
    {/* Mortar lines */}
    <line x1="0" y1="27" x2="200" y2="27" stroke="#A0A0A0" strokeWidth="2" strokeDasharray="2,2"/>
    <line x1="0" y1="50" x2="200" y2="50" stroke="#A0A0A0" strokeWidth="2" strokeDasharray="2,2"/>
    <line x1="0" y1="73" x2="200" y2="73" stroke="#A0A0A0" strokeWidth="2" strokeDasharray="2,2"/>
  </svg>
);
